import React, { useMemo } from 'react';

const useCombinedCategories = (categoryWiseRating, categoryData) => {
  let parsedData = [];
  try {
    parsedData = typeof categoryData === 'string'
      ? JSON.parse(categoryData)
      : categoryData || [];
  } catch (err) {
    console.error('Failed to parse categoryData:', err);
  }

  const isValidCategoryWiseRating = categoryWiseRating && typeof categoryWiseRating === 'object';

  console.log(parsedData, 'parsedData', categoryData, 'cawise', categoryWiseRating);
  const ratingToCategoryId = {
    engine_health_and_diagnostics: 7, // Engine Health and Diagnostics
    transmission_assessment: 8, // Transmission System Diagnosis
    air_condition_system_check: 6, // Air Condition System Check
    battery_health_checkup: 9, // Battery Health Checkup
    suspension_brakes_and_battery: 10, // Suspension & Brakes Inspection
    exterior_evaluation: 2, // Exterior Inspection
    interior_evaluation: 4, // Interior Inspection
    infotainment_electrical_systems_accessories_analysis: 5, // Infotainment, Electrical System and Accessories Check
    head_lights_and_indicators: 3, // Headlights and Indictaor Inspection
    tires_and_tools: 11, // Tires and Tools Inspection
  };

  const categoryOrder = [
    'engine_health_and_diagnostics',
    'transmission_assessment',
    'air_condition_system_check',
    'battery_health_checkup',
    'suspension_brakes_and_battery',
    'exterior_evaluation',
    'interior_evaluation',
    'infotainment_electrical_systems_accessories_analysis',
    'head_lights_and_indicators',
    'tires_and_tools'
  ];

  return useMemo(() => {
    if (!isValidCategoryWiseRating) {
      console.warn('categoryWiseRating is invalid or undefined');
      return [];
    }
    
    return categoryOrder?.map(key => {
      if (!categoryWiseRating[key]) return null;
      
      const targetCategoryId = ratingToCategoryId[key];
      const matchingCategory = parsedData.find(
        (cat) => cat.category_id === targetCategoryId
      );
      
      return {
        key,
        rating: categoryWiseRating[key],
        title: matchingCategory ? matchingCategory.titile : key,
        total_questions: matchingCategory ? matchingCategory.total_questions : 0,
        inspectionQuestions: matchingCategory ? matchingCategory.questionary : [],
      };
    }).filter(Boolean);
  }, [categoryOrder, categoryWiseRating, ratingToCategoryId, parsedData]);
};

export default useCombinedCategories;
